// Removed unused import
import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-ai-recon-key'

const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    query: '',
    items: [],
    filters: {},
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_pagination(state, payload) {
        state.pagination = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },

    SET_QUERY(state, payload) {
        state.filters = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `ai-recon`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_item',
                context.state.items.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll({ commit }, { query = '', page = 0 }) {
        const page_no = page
        let path = 'ai-recon'
        
        if (query && query.length > 0) {
            path += `?q=${query}`
        }
        
        if (page_no > 0) {
            const separator = query && query.length > 0 ? '&' : '?'
            path += `${separator}page=${page_no}`
        }
        
        try {
            const response = await api('get', path)
            const responseData = response.data.success.data
            
            if (page_no == 0) {
                // Check if responseData is already an array or if it's a pagination object
                const items = Array.isArray(responseData) ? responseData : (responseData.data || [])
                commit("set_items", items)
            } else {
                const paginationData = responseData
                commit("set_items", paginationData.data || [])
                commit("set_pagination", {
                    page: paginationData.current_page || 1,
                    pageSize: paginationData.per_page || 15,
                    total: paginationData.total || 0
                })
            }
        } catch (error) {
            console.error('AiRecon store API error:', error)
            throw error
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `ai-recon/${payload.id}`,
                payload
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                data,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `ai-recon/${id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_item', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.items },
                null,
                id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}